export class Pole {
    id: number;
    pole: string;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/pole.ts